const liveURL = (window.location.origin === 'http://localhost:8080' || window.location.origin === 'http://localhost:8081')
  ? 'https://derdachstein.myincert.com'
  : window.location.origin;
const testURL = 'https://derdachstein.dev-myincert.com';

export {liveURL, testURL}